export const procedimientosHistoricos = [
    {
        'recurso' : 'Licitaciones 2026',
        'url' : 'Licitaciones/LicitacionesAnteriores/2026',
        'icoHistorico' : 'icon-public-tender',
    },
    {
        'recurso' : 'Invitaciones 2026',
        'url' : 'Invitaciones/InvitacionesAnteriores/2026',
        'icoHistorico' : 'icon-invitation',
    },
    {
        'recurso' : 'Licitaciones 2025',
        'url' : 'Licitaciones/LicitacionesAnteriores/2025',
        'icoHistorico' : 'icon-public-tender',
    },
    {
        'recurso' : 'Invitaciones 2025',
        'url' : 'Invitaciones/InvitacionesAnteriores/2025',
        'icoHistorico' : 'icon-invitation',
    },
    {
        'recurso' : 'Licitaciones 2024',
        'url' : 'Licitaciones/LicitacionesAnteriores/2024',
        'icoHistorico' : 'icon-public-tender',
    },
    {
        'recurso' : 'Licitaciones 2023',
        'url' : 'Licitaciones/LicitacionesAnteriores/2023',
        'icoHistorico' : 'icon-public-tender',
    },
    {
        'recurso' : 'Licitaciones 2022',
        'url' : 'Licitaciones/LicitacionesAnteriores/2022',
        'icoHistorico' : 'icon-public-tender',
    },
    {
        'recurso' : 'Invitaciones 2022',
        'url' : 'Invitaciones/InvitacionesAnteriores/2022',
        'icoHistorico' : 'icon-invitation',
    },
    // {
    //     'recurso' : 'Licitaciones 2021',
    //     'url' : 'Licitaciones/LicitacionesAnteriores/2021',
    //     'icoHistorico' : 'icon-public-tender',
    // },
    // {
    //     'recurso' : 'Concurso Público APP 2021',
    //     'icoHistorico' : 'icon-public-contest',
    //     'url' : 'CPAPP/Cpapp/2021',
    // },
    // {
    //     'recurso' : 'Licitaciones 2020',
    //     'url' : 'Licitaciones/LicitacionesAnteriores/2020',
    //     'icoHistorico' : 'icon-public-tender',
    // },
    // {
    //     'recurso' : 'Concurso Público APP 2020',
    //     'url' : 'CPAPP/Cpapp/2020',
    //     'icoHistorico' : 'icon-public-contest',
    // },
    // {
    //     'recurso' : 'Licitaciones 2019',
    //     'url' : 'Licitaciones/LicitacionesAnteriores/2019',
    //     'icoHistorico' : 'icon-public-tender',
    // },
    // {
    //     'recurso' : 'Invitaciones 2019',
    //     'url' : 'Invitaciones/InvitacionesAnteriores/2019',
    //     'icoHistorico' : 'icon-invitation',
    // },
    // {
    //     'recurso' : 'Licitaciones 2018',
    //     'url' : 'Licitaciones/LicitacionesAnteriores/2018',
    //     'icoHistorico' : 'icon-public-tender',
    // },
    // {
    //     'recurso' : 'Invitaciones 2018',
    //     'url' : 'Invitaciones/InvitacionesAnteriores/2018',
    //     'icoHistorico' : 'icon-invitation',
    // },
]